import React from 'react';
import PropTypes from 'prop-types';
import { Text, Flex, Image, Heading } from "./..";
import { rem } from 'polished';

var ValueItem = function ValueItem(_ref) {
  var icon = _ref.icon,
      heading = _ref.heading,
      children = _ref.children,
      _ref$layout = _ref.layout,
      layout = _ref$layout === void 0 ? 'column' : _ref$layout,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? '280px' : _ref$maxWidth;
  var src = icon.src,
      alt = icon.alt;
  var stacked = layout === 'column';
  return /*#__PURE__*/React.createElement(Flex, {
    "data-testid": "valueItem",
    flexDirection: layout,
    alignItems: stacked ? 'center' : 'start',
    maxWidth: maxWidth
  }, /*#__PURE__*/React.createElement(Image, {
    src: src,
    alt: alt,
    size: rem('44px')
  }), /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "column",
    pl: stacked ? 0 : 4
  }, /*#__PURE__*/React.createElement(Heading.h4, {
    fontSize: rem(stacked ? '20px' : '18px'),
    pt: stacked ? 4 : 0,
    textAlign: stacked ? 'center' : 'left'
  }, heading), children && /*#__PURE__*/React.createElement(Text, {
    textAlign: stacked ? 'center' : 'left',
    color: "greys.steel",
    fontSize: stacked ? 'lg' : 'md'
  }, children)));
};

ValueItem.propTypes = {
  icon: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired
  }).isRequired,
  heading: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  layout: PropTypes.oneOf(['row', 'column']),
  maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array])
};
export default ValueItem;